import { ArrowDownwardTwoTone, ArrowUpwardTwoTone } from "@mui/icons-material";
import {
  Icon,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";

interface Transaction {
  id: number;
  type: string;
  quantity: string;
  customer_type: string;
  createdAt: string;
  updatedAt: string;
  date: string;
  product_lists: any[]; // You might want to define a proper type for product_lists
  container: {
    id: number;
    type: string;
    quantity: string;
    is_used: boolean;
    name: string;
    createdAt: string;
    updatedAt: string;
    publishedAt: string | null;
  };
}

interface TransactionsTableProps {
  transactions: Transaction[];
}

const TransactionsTable: React.FC<TransactionsTableProps> = ({
  transactions,
}) => {

  const dates = transactions?.map((item) => item?.date);

  const cleanDates = dates?.filter(
    (item, index) => dates?.indexOf(item) === index
  );


  const getDataPerDate = (date: string, type: "in" | "out") => {
    return transactions?.filter(
      (item) => item?.date === date && item?.type === type
    );
  };

  // const dataPerDates =

  const _transactionsPerDate = {
    date1: {
      in: [],
      out: [],
    },
    date2: {
      in: [],
      out: [],
    },
  };

  return (
    <Paper>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Date</TableCell>
            <TableCell>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography>IN</Typography>
                <Icon>
                  <ArrowDownwardTwoTone
                    fontSize="small"
                    sx={{ color: "green" }}
                  />
                </Icon>
              </Stack>
            </TableCell>
            <TableCell>
              <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography>Out</Typography>
                <Icon>
                  <ArrowUpwardTwoTone fontSize="small" sx={{ color: "red" }} />
                </Icon>
              </Stack>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(cleanDates || []).map((item) => (
            <TableRow key={item}>
              <TableCell>{item}</TableCell>
              <TableCell
                sx={{
                  bgcolor: "#28b5288a",
                }}
              >
                <Stack width="100%">
                  {getDataPerDate(item, "in")?.map((item, index) => (
                    <Stack
                      key={index}
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                      spacing={1}
                      width="100%"
                    >
                      <Typography fontWeight={700}>
                        {item?.container?.name}
                      </Typography>
                      <Typography
                        fontWeight={500}
                        sx={{
                          float: "right",
                        }}
                      >
                        {item?.quantity}
                      </Typography>
                    </Stack>
                  ))}
                </Stack>
              </TableCell>
              <TableCell
                sx={{
                  bgcolor: "#ff7373",
                }}
              >
                <Stack width="100%">
                  {getDataPerDate(item, "out")?.map((item, index) => (
                    <Stack
                      key={index}
                      direction="row"
                      alignItems="center"
                      justifyContent="space-between"
                      spacing={1}
                      width="100%"
                    >
                      <Typography fontWeight={700}>
                        {item?.container?.name}
                      </Typography>
                      <Typography
                        fontWeight={500}
                        sx={{
                          float: "right",
                        }}
                      >
                        {item?.quantity}
                      </Typography>
                    </Stack>
                  ))}
                </Stack>
              </TableCell>
              {/* <TableCell>{transaction.quantity}</TableCell>
              <TableCell>{transaction.customer_type}</TableCell>
              <TableCell>{transaction.createdAt}</TableCell>
              <TableCell>{transaction.updatedAt}</TableCell>
              <TableCell>{transaction.container.id}</TableCell>
              <TableCell>{transaction.container.type}</TableCell>
              <TableCell>{transaction.container.quantity}</TableCell> */}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
};

export default TransactionsTable;
